export default __webpack_public_path__ + "static/media/pdfIcon.bcf5df77.svg";